import * as z from "zod";

export const getBrightpearlSalesCreditStatuses = {
  name: "getBrightpearlSalesCreditStatuses" as const,
  input: z.object({}),
  output: z.object({
    salesCreditStatuses: z.array(
      z.object({ statusId: z.number(), name: z.string() }),
    ),
  }),
};
